import React from 'react';
import ContentStep from './ContentStep';
import SkillActions from 'actions/SkillActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import SkillStore from 'stores/SkillStore';
import UserStore from 'stores/UserStore';
import DirectReportsActions from 'actions/coaching/DirectReportsActions';
import DirectReportsStore from 'stores/coaching/DirectReportsStore';
import {List} from 'immutable';
import CoachingContentDetail, {defaultSkillGoal} from 'records/CoachingContentDetail';

class ContentStepContainer extends React.PureComponent {
  static getStores() {
    return [AuthStore, SkillStore, UserStore, DirectReportsStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
      ...SkillStore.getState(),
      UserStore: UserStore.getState(),
    };
  }

  async componentDidMount() {
    const {model: plan, onChange, completedSteps, step, editMode, skillToCoach} = this.props;

    const [skills] = await SkillActions.fetchAllByTeam({
      team_id: plan.recipient.info.teamId,
    });

    // if we already set the content detail, are edit mode,
    // or generally already have content details (came from mini wizard)
    // - bail
    if (
      completedSteps.has(step) ||
      editMode ||
      plan.contentDetails.find(cd => cd.skillName !== null)
    )
      return;

    if (!plan.recipient || !plan.recipient.info) return;

    // We are calling getChallengedBy before we check for editMode, I assume it's for a reason,
    // so not touching this block of code even if skillToCoach is set
    const skillBreakdown = await DirectReportsActions.getSkillBreakdown(List([plan.recipient.id]));

    // If we're editing don't try to create a default
    if (editMode) return;

    const challengedBySkill = skillBreakdown.find(c => c.userId === plan.recipient.id)?.worstSkill
      .skillName;

    if (!challengedBySkill && !skillToCoach) return;

    // skillToCoach takes precedence over the BE's suggestion
    const defaultSkillNameToCoach = skillToCoach ? skillToCoach : challengedBySkill.skill;
    const defaultSkillToCoach = skills.find(s => defaultSkillNameToCoach === s.skill);

    if (!defaultSkillToCoach) return;

    const newContentDetails = List([
      new CoachingContentDetail({
        skillId: defaultSkillToCoach.id,
        skillName: defaultSkillToCoach.skill,
        isSkillBased: true,
        skillGoal: defaultSkillGoal,
      }),
    ]);

    const defaultedCoachingPlan = plan.set('contentDetails', newContentDetails);
    onChange(defaultedCoachingPlan);
  }

  render() {
    const {model: plan, skillsByTeam} = this.props;
    const skills = skillsByTeam?.get(plan.recipient.info.teamId) || List();

    return <ContentStep {...this.props} skills={skills} />;
  }
}

const connectedComponent = connectToStores(ContentStepContainer);
connectedComponent.title = ContentStep.title;
connectedComponent.validate = ContentStep.validate;
export default connectedComponent;
